export const ITALIAN_REGIONS: Record<string, readonly string[]> = {
  'ABRUZZO': ['CHIETI', 'L\'AQUILA', 'PESCARA', 'TERAMO'],
  'BASILICATA': ['MATERA', 'POTENZA'],
  'CALABRIA': ['CATANZARO', 'COSENZA', 'CROTONE', 'REGGIO CALABRIA', 'VIBO VALENTIA'],
  'CAMPANIA': ['AVELLINO', 'BENEVENTO', 'CASERTA', 'NAPOLI', 'SALERNO'],
  'EMILIA-ROMAGNA': ['BOLOGNA', 'FERRARA', 'FORLI-CESENA', 'MODENA', 'PARMA', 'PIACENZA', 'RAVENNA', 'REGGIO EMILIA', 'RIMINI'],
  'FRIULI VENEZIA GIULIA': ['GORIZIA', 'PORDENONE', 'TRIESTE', 'UDINE'],
  'LAZIO': ['FROSINONE', 'LATINA', 'RIETI', 'ROMA', 'VITERBO'],
  'LIGURIA': ['GENOVA', 'IMPERIA', 'LA SPEZIA', 'SAVONA'],
  'LOMBARDIA': ['BERGAMO', 'BRESCIA', 'COMO', 'CREMONA', 'LECCO', 'LODI', 'MANTOVA', 'MILANO', 'MONZA E BRIANZA', 'PAVIA', 'SONDRIO', 'VARESE'],
  'MARCHE': ['ANCONA', 'ASCOLI PICENO', 'FERMO', 'MACERATA', 'PESARO E URBINO'],
  'MOLISE': ['CAMPOBASSO', 'ISERNIA'],
  'PIEMONTE': ['ALESSANDRIA', 'ASTI', 'BIELLA', 'CUNEO', 'NOVARA', 'TORINO', 'VERBANO-CUSIO-OSSOLA', 'VERCELLI'],
  'PUGLIA': ['BARI', 'BARLETTA-ANDRIA-TRANI', 'BRINDISI', 'FOGGIA', 'LECCE', 'TARANTO'],
  'SARDEGNA': ['CAGLIARI', 'CARBONIA-IGLESIAS', 'MEDIO CAMPIDANO', 'NUORO', 'OGLIASTRA', 'OLBIA-TEMPIO', 'ORISTANO', 'SASSARI'],
  'SICILIA': ['AGRIGENTO', 'CALTANISSETTA', 'CATANIA', 'ENNA', 'MESSINA', 'PALERMO', 'RAGUSA', 'SIRACUSA', 'TRAPANI'],
  'TOSCANA': ['AREZZO', 'FIRENZE', 'GROSSETO', 'LIVORNO', 'LUCCA', 'MASSA-CARRARA', 'PISA', 'PISTOIA', 'PRATO', 'SIENA'],
  'TRENTINO-ALTO ADIGE': ['BOLZANO', 'TRENTO'],
  'UMBRIA': ['PERUGIA', 'TERNI'],
  'VALLE D\'AOSTA': ['AOSTA'],
  'VENETO': ['BELLUNO', 'PADOVA', 'ROVIGO', 'TREVISO', 'VENEZIA', 'VERONA', 'VICENZA'],
} as const;

export const ITALIAN_REGION_NAMES = Object.keys(ITALIAN_REGIONS) as string[];

export function getProvincesForRegion(region: string): string[] {
  return [...(ITALIAN_REGIONS[region] || [])];
}

export function getRegionForProvince(province: string): string | null {
  for (const [region, provinces] of Object.entries(ITALIAN_REGIONS)) {
    if ((provinces as readonly string[]).includes(province)) {
      return region;
    }
  }
  return null;
}
